import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3v18","key":"svg-0"}],["path",{"d":"M9 18l3 3l3 -3","key":"svg-1"}],["path",{"d":"M9 3h6","key":"svg-2"}]]

const IconArrowDownBar = createReactComponent('outline', 'arrow-down-bar', 'ArrowDownBar', __iconNode);

export default IconArrowDownBar;